import { render, staticRenderFns } from "./CommentaryListItemComponent.vue?vue&type=template&id=7b650a90&"
import script from "./CommentaryListItemComponent.vue?vue&type=script&lang=js&"
export * from "./CommentaryListItemComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports